<script lang="ts">
  export let message = "No map available";
</script>

<section>
  <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
    />
  </svg>

  <h1 class="type-h2">{message}</h1>
</section>

<style>
  @keyframes fade-in-slowly {
    0% {
      opacity: 0;
      transform: scale(0.98);
    }

    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  section {
    animation: 3s fade-in-slowly;
    animation-delay: 1s;
    animation-fill-mode: both;
    align-items: center;
    color: white;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    padding: 48px;
    text-align: center;
    width: 100%;
  }

  svg {
    margin-bottom: 16px;
    color: #aaa;
  }
</style>
